import React, { useState, useRef } from "react";
import { Upload, message, Select } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, SelectItem } from "../../../../../Components/Items";
import SelectDocumentoItem from "../../../../../Components/SelectDocumentoItem";
import SegmentedItem from "../../../../../Components/SegmentedItem";
import TextAreaItem from "../../../../../Components/TextAreaItem";
import BarraFormato from "../BarraFormato";
import { selectorDeModelo } from "../Helpers/plantillasHelpers";

let _cmSeq = 0;

// Modelos cuyo PDF se puede generar en el backend y enviar como documento.
const MODELOS_PDF = [
  { value: "cotizacion", label: "Cotización" },
  { value: "pedido", label: "Pedido" },
  { value: "venta", label: "Venta" },
  { value: "ordencompra", label: "Orden de Compra" },
];
const DROPDOWN = { zIndex: 1200 };

// Por defecto se elige un documento del sistema 
const OPCIONES_FUENTE = [
  { label: "Documento del sistema (PDF)", value: "documento" },
  { label: "Subir archivo", value: "archivo" },
];

const ComposerMedia = ({ visible, tipo, accept, titulo, headersToken, empresaId, onCancel, onEnviar }) => {
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [fuente, setFuente] = useState("documento");
  const [modelo, setModelo] = useState(undefined);
  const [documentoId, setDocumentoId] = useState(null);
  const idCaption = useRef(`wa-cm-caption-${++_cmSeq}`).current;

  const esDocumento = tipo === "document";

  const limpiar = () => {
    setFile(null);
    setCaption("");
    setFuente("documento");
    setModelo(undefined);
    setDocumentoId(null);
  };

  const cerrar = () => {
    limpiar();
    onCancel();
  };

  const enviar = () => {
    if (esDocumento && fuente === "documento") {
      if (!modelo) return message.error("Elige el tipo de documento.");
      if (!documentoId) return message.error("Selecciona el documento.");
      const fd = new FormData();
      fd.append("tipo", tipo);
      fd.append("modelo", modelo);
      fd.append("documentoId", documentoId);
      if (caption) fd.append("caption", caption);
      onEnviar(fd);
      limpiar();
      return;
    }
    if (!file) return message.error("Selecciona un archivo.");
    const fd = new FormData();
    fd.append("archivo", file);
    fd.append("tipo", tipo);
    if (caption) fd.append("caption", caption);
    onEnviar(fd);
    limpiar();
  };

  const docTipo = selectorDeModelo(modelo)?.documentoTipo;

  return (
    <ModalItem
      title={titulo}
      visible={visible}
      onCancel={cerrar}
      width={520}
      zIndex={1100}
      destroyOnClose
      spinning={false}
    >
      {esDocumento && (
        <div style={{ marginBottom: 12 }}>
          <SegmentedItem
            options={OPCIONES_FUENTE}
            value={fuente}
            onChange={(v) => { setFuente(v); setFile(null); setModelo(undefined); setDocumentoId(null); }}
          />
        </div>
      )}

      {esDocumento && fuente === "documento" ? (
        <>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Tipo de documento</div>
          <SelectItem
            value={modelo}
            onChange={(v) => { setModelo(v); setDocumentoId(null); }}
            width="100%"
            placeholder="Cotización, pedido, venta, orden de compra..."
            dropdownStyle={DROPDOWN}
          >
            {MODELOS_PDF.map((m) => <Select.Option key={m.value} value={m.value}>{m.label}</Select.Option>)}
          </SelectItem>
          {modelo && (
            <div style={{ marginTop: 8 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Buscar documento</div>
              <SelectDocumentoItem
                tipo={docTipo}
                headersToken={headersToken}
                empresaId={empresaId}
                width="100%"
                style={{ width: "100%" }}
                placeholder="Buscar..."
                dropdownStyle={DROPDOWN}
                onChange={(id) => setDocumentoId(id || null)}
              />
            </div>
          )}
        </>
      ) : (
        <>
          <Upload.Dragger
            accept={accept}
            showUploadList={false}
            beforeUpload={(f) => {
              setFile(f);
              return false;
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Haz clic o arrastra el archivo aquí</p>
          </Upload.Dragger>
          {file && (
            <div style={{ marginTop: 8 }}>
              Seleccionado: <b>{file.name}</b>
            </div>
          )}
        </>
      )}

      {tipo === "sticker" && (
        <div style={{ marginTop: 8, fontSize: 12, color: "#8c8c8c" }}>
          Sube cualquier imagen (PNG, JPG o WebP); se convierte automáticamente a sticker
          WebP de 512×512&nbsp;px optimizado para WhatsApp.
        </div>
      )}
      {tipo !== "audio" && tipo !== "sticker" && (
        <div style={{ marginTop: 12 }}>
          <BarraFormato targetId={idCaption} value={caption} onChange={setCaption} />
          <TextAreaItem
            id={idCaption}
            placeholder="Descripción (opcional)"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            rows={2}
          />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
        <ButtonItem rojo onClick={cerrar}>Cancelar</ButtonItem>
        <ButtonItem cyan onClick={enviar}>Enviar</ButtonItem>
      </div>
    </ModalItem>
  );
};

export default ComposerMedia;
